/* ============================================================
   ESCORPIÓN — Barra de compra fija en móvil
   - Se muestra mientras el botón real "Agregar al carrito" NO está a la vista.
   - Se oculta en cuanto el botón real entra en pantalla.
   - Los botones NO duplican lógica: reenvían el clic al botón real del
     formulario, así se respetan variante, personalización y validaciones.
   - El precio se refleja del bloque de precio de la página (Dawn lo
     re-renderiza al cambiar de variante), por eso se observa con MutationObserver.
   ============================================================ */
(function () {
  function init(bar) {
    var atc = document.querySelector(bar.dataset.atcSelector);
    var priceSource = document.querySelector(bar.dataset.priceSelector);
    var priceTarget = bar.querySelector('[data-esc-sticky-price]');
    var btnCart = bar.querySelector('[data-esc-sticky-action="add"]');
    var btnBuy = bar.querySelector('[data-esc-sticky-action="buy"]');
    if (!atc) return;

    /* ---------- visibilidad ---------- */
    function show() {
      bar.classList.add('is-visible');
    }
    function hide() {
      bar.classList.remove('is-visible');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) hide();
            else show();
          });
        },
        { rootMargin: '0px 0px -40px 0px', threshold: 0 }
      );
      io.observe(atc);
    } else {
      var onScroll = function () {
        var r = atc.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) hide();
        else show();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    /* ---------- precio espejo ---------- */
    function syncPrice() {
      if (!priceSource || !priceTarget) return;
      var regular = priceSource.querySelector('.price-item--regular');
      var sale = priceSource.querySelector('.price-item--sale');
      var compare = priceSource.querySelector('.price-item--regular s, s.price-item--regular');
      var main = (sale && sale.textContent.trim()) || (regular && regular.textContent.trim()) || '';
      if (!main) {
        main = priceSource.textContent.replace(/\s+/g, ' ').trim();
      }
      priceTarget.textContent = main;
      if (compare && compare.textContent.trim() && compare.textContent.trim() !== main) {
        var s = document.createElement('s');
        s.textContent = compare.textContent.trim();
        priceTarget.appendChild(s);
      }
    }

    function syncDisabled() {
      var off = atc.hasAttribute('disabled');
      [btnCart, btnBuy].forEach(function (b) {
        if (!b) return;
        if (off) b.setAttribute('disabled', 'disabled');
        else b.removeAttribute('disabled');
      });
    }

    syncPrice();
    syncDisabled();

    if (window.MutationObserver) {
      if (priceSource) {
        new MutationObserver(syncPrice).observe(priceSource, { childList: true, subtree: true, characterData: true });
      }
      new MutationObserver(syncDisabled).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    }

    /* ---------- acciones ---------- */
    function currentCount() {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (c) {
          return c.item_count;
        })
        .catch(function () {
          return null;
        });
    }

    function waitForCartChange(before, deadline) {
      if (before === null) return Promise.resolve();
      return new Promise(function (resolve) {
        var t0 = Date.now();
        (function poll() {
          currentCount().then(function (now) {
            if (now === null || now !== before || Date.now() - t0 > deadline) return resolve();
            setTimeout(poll, 350);
          });
        })();
      });
    }

    if (btnCart) {
      btnCart.addEventListener('click', function () {
        atc.click();
      });
    }

    if (btnBuy) {
      btnBuy.addEventListener('click', function () {
        if (bar.classList.contains('is-busy')) return;
        // Oct 2026: esc-ventas.js va al pago cuando el tema confirma que la CAMISETA entró
        // (antes de eso entran parches y personalización y el contador ya cambia).
        if (typeof window.escComprarAhora === 'function') {
          if (window.escComprarAhora()) bar.classList.add('is-busy');
          return;
        }
        bar.classList.add('is-busy');
        currentCount().then(function (before) {
          atc.click();
          waitForCartChange(before, 8000).then(function () {
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
          });
        });
      });
    }
  }

  function boot() {
    document.querySelectorAll('.esc-sticky-buy').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
